module.exports = __webpack_public_path__ + "img/jidan.575a92c2.svg";